export default {"src":"/images/11.jpg","width":5053,"height":3369,"aspectRatio":1.499851588008311};